import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export interface BreadcrumbItem {
  id: string | null;
  name: string;
}

interface Props {
  items: BreadcrumbItem[];
}

const Breadcrumb: React.FC<Props> = ({ items }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const goTo = (id: string | null) => {
    const nextPath = id ? `/library/${id}` : '/library';
    navigate(`${nextPath}${location.search}`);
  };

  return (
    <nav className="lib-breadcrumb">
      {items.map((item, idx) => {
        const isLast = idx === items.length - 1;
        return (
          <React.Fragment key={item.id ?? 'root'}>
            {isLast ? (
              <span className="lib-breadcrumb__item lib-breadcrumb__item--active">
                {item.name}
              </span>
            ) : (
              <button className="lib-breadcrumb__item lib-breadcrumb__item--link" onClick={() => goTo(item.id)}>
                {item.name}
              </button>
            )}
            {!isLast && <span className="lib-breadcrumb__sep">/</span>}
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default Breadcrumb;
